import config from "../firebase-config.json";

export const isLocal = ["development", "test"].includes(process.env.NODE_ENV);

export const getConfig = () => {
  return config.result.sdkConfig;
};
